export const makeTdConfig = (year, month, day) => ({
  chartTop: {
    title: '過去の天気',
    description: '【過去の天気｜ウェザーニュース】2021年から現在までの過去天気図を一覧で掲載。昨日や1週間前、去年など天気図の移り変わりでその日の気圧配置と天気の様子がわかります。最新の気象・防災情報は予報精度No.1ウェザーニュースで。',
    keyword: '過去の天気,天気図'
  },
  chartMonth: {
    title: `過去の天気図【${year}${month}】`,
    description: `【${year}${month}の天気図】日毎の天気図の移り変わりを一覧で確認できます。昨日や1週間前、去年など天気図の移り変わりでその日の気圧配置と天気の様子がわかります。最新の気象・防災情報は予報精度No.1ウェザーニュースで。`,
    keyword: `天気図,${year}${month}`
  },
  chartDay: {
    title: `過去の天気図【${year}${month}${day}】`,
    description: `【${year}${month}${day}の天気図】3時間ごとの天気図の変化で、${month}${day}の気圧配置と天気の様子がわかります。最新の気象・防災情報は予報精度No.1ウェザーニュースで。`,
    keyword: `天気図,${year}${month}${day}`
  }
})
